<template>
    <div :class="['border-radius-20', wrapClass ?? 'me-3 bg-gray-200']">
        <input v-if="!avatarOnly" type="file" ref="avatarImageInput" name="image" v-on:input="change($event)"
               id="avatarImage" accept="image/*" class="d-none">

        <img v-if="!letter && !icon"
             :class="['border-radius-20', classes, imgDisplay]"
             :src="url || '/img/avatar.png'" alt="avatar-image"
             :style="{ height: height ? height + 'px' : '32px', width: width ? width + 'px' : '32px' }"/>

        <div v-if="letter && !icon"
             :style="{ height: height ? height + 'px' : '32px', width: width ? width + 'px' : '32px' }"
             class="d-flex align-items-center justify-content-center">
            <h6 class="letter">{{ letter }}</h6>
        </div>

        <div v-if="icon"
             :style="{ height: height ? height + 'px' : '32px', width: width ? width + 'px' : '32px' }"
             class="d-flex align-items-center justify-content-center">
            <i :class="['fi', icon]"></i>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "AvatarImage",
    props: {
        src: String,
        width: [String, Number],
        height: [String, Number],
        classes: String,
        avatarOnly: {
          type: Boolean,
          default: true
        },
        wrapClass: String,
        imgDisplay: {
            type: String,
            default: 'cover'
        },
        letter: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            url: this.src
        }
    },
    watch: {
        src: function (val) {
            this.url = val;
        }
    },
    methods: {
        select() {
            this.$refs.avatarImageInput.click();
        },
        change: function (event) {
            const file = event.target.files[0];
            this.url = URL.createObjectURL(file);
            this.$emit('chosen-file', file)
        },
        changePlaceholderImage(path) {
            this.url = path;
        },
        reset() {
            let input = this.$refs.avatarImageInput;
            input.value = '';
            this.url = null
        },
        deleteImage(id) {
            axios.delete(`/media/${id}`).then(res => {
                this.$emit('file-deleted', res)
            });
        }
    }
}
</script>

<style scoped>
.circle {
    border-radius: 50% !important;
}

.cover {
    object-fit: cover;
}

.contain {
    object-fit: contain;
}

.fill {
    object-fit: fill;
}

.center {
    object-position: center;
}

.left {
    object-position: left;
}

.top {
    object-position: top;
}

.right {
    object-position: right;
}

.bottom {
    object-position: bottom;
}

.letter {
    margin-bottom: 0;
    line-height: 0;
}
</style>
